const Constants = {
  // Falls back to localhost when REACT_APP_SERVER_LINK is not set (local dev).
  // For builds, set REACT_APP_SERVER_LINK in the environment / .env file.
  serverlink: process.env.REACT_APP_SERVER_LINK || 'http://localhost:3000/',
  timeout: 40000,
};

export default Constants;
